import { render, staticRenderFns } from "./Imperfection.vue?vue&type=template&id=1638884a&scoped=true"
import script from "./Imperfection.vue?vue&type=script&lang=js"
export * from "./Imperfection.vue?vue&type=script&lang=js"
import style0 from "./Imperfection.vue?vue&type=style&index=0&id=1638884a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1638884a",
  null
  
)

export default component.exports